const HeaderSimulatorModel = Backbone.Model.extend({

    defaults: {
        isStuck: false,
        isOverLight: false,
        isOverDark: false,
        currentBgColor: null,
        backgrounds: {
            light: '#fff',
            dark: '#1a1a1a'
        },
        classnames: {
            stickyHeader: 'is-stuck',
            overLightRow: 'lqd-active-row-light',
            overDarktRow: 'lqd-active-row-dark'
        },
        selectors: {
            mainHeader: '.main-header',
            dynamicColorElements: '.main-header, .main-header > .elementor .elementor-element'
        }
    }

});

export default HeaderSimulatorModel;